import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

export default function Arbor() {
  return (
    <section className="arbor-section" style={{ padding: "80px 0 100px" }}>
      <Container>
        <Row>
          <Col lg="7" className="mx-auto text-white">
            <div className="arbor-content text-center">
              <h3 className="section-subtitle mb-5 text-whitez">
                SOCIAL IMPACT
              </h3>
              <h2 className="section-title mb-5">
                What is Conscious Consumerism?
              </h2>
              <p className="mb-6">
                Conscious Consumerism: What it is; What to look for; and ultimately, change the way we do business.
              </p>
              <Link to="/what-is-conscious-consumerism/" className="cta text-uppercase">
                Read
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
